// extracted by mini-css-extract-plugin
module.exports = {"introContainer":"_2f8nHm","introOptionsWrapper":"bCh0uu","introOption":"_1g5v48"};